




<div class="wrapper">
    <div class="left-side">
    </div>
    <div class="right-side">
        <form class="form-container login-page text-center w-75" [formGroup]="form">
            <div class="login-brand">
                <img src="assets/img/cogent-logo.png" alt="COGENT" class="login-brand-logo">
            </div>
                <h1 class="fw-bolder mt-4 fs-2">{{'GRMS' | translate}}</h1>
                <p class="fs-5 text-secondary mb-4">{{'SALAM' | translate}}</p>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'UserName' | translate}} </mat-label>
                        <input matInput type="text" autocomplete="username" placeholder="User Name" formControlName="userName">
                        @if (f['userName'].errors) {
                        <mat-error>
                            @if (f['userName'].errors['required']) { <span>{{'USER_NAME_REQUIRED' | translate}}</span>}
                            @if (f['userName'].errors['maxLength']) { <span>{{'MAX_LENGTH_30' | translate}}</span>}
                             @if (f['userName'].errors['pattern']) { <span>{{'INVALID_USERNAME_PATTERN' | translate}}</span>}
                           
                            <!-- @if (f['userName'].errors['pattern']) { <span>{{'ONLY_ALPHA_NUMERIC' | translate}}</span>} -->
                        </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'PASSWORD' | translate}} </mat-label>
                        <input matInput type="password" autocomplete="current-password" placeholder="Password" formControlName="password">
                        @if (f['password'].errors) {
                        <mat-error>
                            @if (f['password'].errors['required']) { <span>{{'PASSWORD_REQUIRED' | translate}}</span>}
                            <!-- @if (f['password'].errors['maxLength']) { <span>{{'MAX_LENGTH_30' | translate}}</span>}
                            @if (f['password'].errors['pattern']) { <span>{{'PASSWORD_PATTERN' | translate}}</span>}
                            @if (f['password'].errors['minLength']) { <span>{{'MINLENGTH_8' | translate}}</span>} -->
                        </mat-error>
                        }
                    </mat-form-field>
                    <button mat-raised-button type="button" color="primary" (click)="login()" class="w-100">Login</button>
                    <a mat-button class="forgot-password-link text-secondary" [routerLink]="'/forget-password'">Forgot Password?</a>
        </form>
    </div>
</div>
